import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { injectIntl, intlShape } from 'react-intl';

import { kustyColored } from 'globals/assets';
import styles from './styles';
import messages from './messages';

class IconDefaultColored extends PureComponent {
  render() {
    const { color, intl } = this.props;

    const bgStyles = Object.assign({}, styles.default, {
      backgroundImage: `url('${kustyColored(color)}')`,
    });

    return (
      <div role="img" aria-label={intl.formatMessage(messages.aria_label_default_colored_icon)} style={bgStyles} />
    );
  }
}

IconDefaultColored.propTypes = {
  color: PropTypes.string,
  intl: intlShape.isRequired,
};

IconDefaultColored.defaultProps = {
  color: '#0A3355',
};

export default injectIntl(IconDefaultColored);
